<template>
  <div>
    <v-container class="px-8 pt-0 accept-page">
      <v-row class="ma-0 pa-0 inner-padding">
        <v-col cols="12" class="pa-0 text-center">
          <v-avatar color="#f4f6f7" size="124">
            <div class="accept-icon-wrap">
              <v-img class="mx-auto" src="@/assets/img/icon_document.png" />
            </div>
          </v-avatar>
        </v-col>
      </v-row>

      <v-row class="mt-6 mb-0 pa-0">
        <v-col cols="12" class="pa-0 text-center desc">
          정보 수집약관에 동의하고,<br />
          워크업을 시작해보세요.
        </v-col>
      </v-row>

      <v-container class="pa-0 agree-wrap" :class="{ checked: isAllChecked }">
        <v-row class="ma-0 pa-0">
          <v-col cols="12" class="ma-0 pa-0">
            <v-btn
              class="all-agree"
              elevation="0"
              block
              color="white"
              @click="allCheckItem"
            >
              <v-icon class="mr-4 all-check">mdi-check</v-icon>
              모두 동의하기
            </v-btn>
          </v-col>
        </v-row>

        <v-list class="mt-4">
          <v-list-item v-for="(item, i) in items" :key="i" class="px-0">
            <v-list-item-icon
              class="pl-4 mr-4 my-3 check-item"
              :class="{ checked: item.checkFlag }"
              @click="checkItem(i)"
            >
              <v-icon class="checked">mdi-check</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="d-flex">
                <span>{{ item.text }}</span>
                <span style="color: #9ca3ab">(필수)</span>
              </v-list-item-title>
            </v-list-item-content>

            <v-list-item-icon class="my-3" @click="toPolicyDetail(item.path)">
              <v-icon color="#9ca3ab">mdi-chevron-right</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list>
      </v-container>

      <!-- 시작하기 버튼 -->
      <v-bottom-navigation
        fixed
        scroll-target="#scroll-threshold-example"
        scroll-threshold="500"
        height="88"
        style="box-shadow: none"
      >
        <v-row class="ma-0 pb-8 px-8 btn-fixed-wrapper">
          <v-col cols="12">
            <v-btn
              block
              elevation="0"
              class="btn-fixed btn-blue"
              :class="{ disabled: !isAllChecked }"
              color="blue"
              @click="toLogin()"
            >
              <span class="white--text">시작하기</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-bottom-navigation>
    </v-container>
  </div>
</template>

<script>
/* 정보수집약관동의 (앱최초 접속시) */
import routerNames from '@/const/routerConstants';
import { callApp } from '@/utils/app/callApp.js';

export default {
  data: () => ({
    items: [
      {
        text: '서비스이용약관',
        path: '/policyConsent/service',
        checkFlag: false,
      },
      {
        text: '개인정보처리방침',
        path: '/policyConsent/privacy',
        checkFlag: false,
      },
    ],
  }),

  computed: {
    /* 전체체크확인 */
    isAllChecked() {
      return this.items.every(item => item.checkFlag);
    },
  },

  methods: {
    /* 정책상세페이지로 이동 */
    toPolicyDetail(path) {
      this.$router.push(path);
    },

    /* 로그인페이지로 이동 */
    toLogin() {
      // 방어로직
      if (!this.isAllChecked) {
        alert('약관 동의 후 시작할 수 있습니다');
        return;
      }
      // 정책동의여부 앱에 전달
      callApp.agreePolicy();

      this.$router.push({ name: routerNames.Login });
    },

    /* 개별 체크 */
    checkItem(index) {
      this.items[index]['checkFlag'] = !this.items[index]['checkFlag'];
    },

    /* 전체 체크 */
    allCheckItem() {
      const changeVal = !this.isAllChecked; // 변경값

      this.items.forEach(item => {
        if (changeVal != item.checkFlag) item.checkFlag = !item.checkFlag;
      });
    },
  },
};
</script>
